"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchVerifyOtp = void 0;
const fetchVerifyOtp = (api, progressId, body, url) => api.POST(url, body, {
    headers: {
        progressId,
    },
});
exports.fetchVerifyOtp = fetchVerifyOtp;
//# sourceMappingURL=resolver.js.map